export default __webpack_public_path__ + "static/B0133-0f5d964b5c35c7fd7a8575727f0c427f.png";